export function GetAccountName (account) {
  let output = ''

  if (account.firstname) {
    output = account.firstname
    if (account.lastname) {
      output += ' ' + account.lastname
    }
  } else {
    output = account.email || account.username
  }

  return output
}



// WEBPACK FOOTER //
// ./src/helpers/account.js